import React, { useEffect }  from 'react';

import { useDispatch } from 'react-redux';
import * as stockActions from 'modules/stock';

import IssueRanking from 'Components/IssueRanking';
import IssueRealtime from 'Components/IssueRealtime';

const Issue = ({ location, history }) => {
  const dispatch = useDispatch();

  
  useEffect(()=>{
    dispatch(stockActions.initStockCodeMap());
  },[dispatch]);


  return (
    <>
      <IssueRanking />
      <IssueRealtime />
    </>
  )
}

export default Issue;